import gql from 'graphql-tag';
import {propertyCarouselStayUiFragments} from '@homeaway/react-property-carousel';

export const ManageBookingQuery = gql`
    query cancellationQuery(
        $conversationUuid: String!
        $currency: String!
        $listingIds: [String]!
        $startDate: String
        $endDate: String
    ) {
        cancellationReasons {
            category
            descriptionText
            reasons {
                reason
                text
            }
            text
        }
        getTravelerStay(conversationId: $conversationUuid) {
            stayState {
                currentStateOfStay {
                    actions {
                        id
                    }
                }
                stateOfStayData {
                    autoCancellationSummary {
                        continueLabel
                        message: refundMessage
                        title
                        vasMessage
                    }
                    cancellationPolicies {
                        cancellationPolicyPeriods {
                            label
                        }
                        cancellationTimelinePeriods {
                            iconCode
                            isActive
                            isPast
                            refundPercent
                            refundWindowLabel
                            shortDateLocalized
                            timelineLabel
                        }
                        policyType
                        unstructuredPolicyFreeText
                    }
                    cancellationPoliciesNote
                    existingRequest {
                        actions {
                            label
                            time
                        }
                        body
                        state
                        submittedText
                        title
                    }
                    refund {
                        refundableTotalDecimalAmount
                    }
                }
            }
        }
        recommendedListingResponse(
            endDate: $endDate
            listingTriads: $listingIds
            startDate: $startDate
            target: STAY_SIMILAR_PROPERTY
        ) {
            ...PropertyCarouselStayUiRecommendedListingResponse
        }
    }
    ${propertyCarouselStayUiFragments.RecommendedListingResponse}
`;
